<div class="apmt-event-wrap">
  <div class="middle">
    <div class="title border">
      <p class="txt">결 제 예 정</p>
    </div>
    <div class="desc">
      <p class="txt">{{date}}</p>
    </div>
  </div>
</div>
